// Centralized device detection. Exposed both as an ES module export and as `window.device`
// (mirroring the window.bootstrap / window.TomSelect convention) so compilers and other helpers
// can reuse it without importing.

const ua = navigator.userAgent || '';

// iPadOS 13+ reports itself as a desktop Mac, so detect a touch-capable "MacIntel" as iPad.
const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

const isIPhone = /iPhone/.test(ua);
const isIPad = /iPad/.test(ua) || isIPadOS;
const isIOS = /iP(hone|od|ad)/.test(ua) || isIPadOS;
const isAndroid = /Android/.test(ua);
const isTouch = (navigator.maxTouchPoints || 0) > 0;

// Reads env(safe-area-inset-top) in CSS px (requires viewport-fit=cover, which the layout sets).
// Orientation-dependent: the top inset collapses to ~0 in landscape, so read it from portrait.
function safeAreaInsetTop() {
  const probe = document.createElement('div');
  probe.style.cssText =
    'position:fixed;top:0;left:0;width:0;height:env(safe-area-inset-top,0px);pointer-events:none;visibility:hidden;';
  document.documentElement.appendChild(probe);
  const inset = probe.getBoundingClientRect().height;
  probe.remove();
  return inset;
}

// Dynamic Island is iPhone-only and reports a notably larger top safe-area inset (~59px portrait)
// than notch devices (~47px), so the inset is a reliable, device-list-free signal. Evaluated live
// (not cached) because it depends on the current orientation.
function hasDynamicIsland() {
  return isIPhone && safeAreaInsetTop() >= 55;
}

const device = {
  isIPhone,
  isIPad,
  isIOS,
  isAndroid,
  isTouch,
  safeAreaInsetTop,
  hasDynamicIsland,
};

window.device = device;

export default device;
